import { Box, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import { K, KUMO_FONT } from './PageComponentElementCollectionProducts';

// Titled text list ("Daftar Poin") — the storefront's only body-text block.
// Built for syarat & ketentuan, FAQ, care instructions: an optional heading
// plus lines rendered as a real <ol>/<ul>, so numbering and bullets come from
// the browser rather than hand-drawn markers.
export interface BlockTitledListData {
  title?: string;
  // true => numbered (1. 2. 3.), false/undefined => bullets.
  ordered?: boolean;
  lines?: string[];
  containerMargin?: string;
}

export default function BlockTitledList({ elementContentJson }: { elementContentJson: any }) {
  const elementContent: BlockTitledListData = elementContentJson ?? {};
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

  const title = (elementContent.title ?? '').trim();
  // Blank rows are an authoring artifact (the editor always keeps one empty
  // row), never a rendered empty bullet.
  const lines = (Array.isArray(elementContent.lines) ? elementContent.lines : [])
    .map((line) => (typeof line === 'string' ? line.trim() : ''))
    .filter(Boolean);

  if (!title && !lines.length) return null;

  const ListTag = elementContent.ordered ? 'ol' : 'ul';

  return (
    <Box style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <Box style={{
        width: isDesktop ? '81%' : '92%',
        margin: elementContent.containerMargin ?? (isDesktop ? '25px auto 20px' : '15px auto 10px'),
        fontFamily: KUMO_FONT,
        color: K.text,
      }}>
        {!!title &&
          <Box style={{ fontSize: isDesktop ? 20 : 17, fontWeight: 600, marginBottom: 10 }}>
            {title}
          </Box>}
        {!!lines.length &&
          <ListTag style={{
            margin: 0,
            paddingLeft: 22,
            fontSize: isDesktop ? 15 : 14,
            lineHeight: 1.7,
            color: K.secondary,
          }}>
            {lines.map((line, i) => (
              <li key={i} style={{ marginBottom: 4 }}>{line}</li>
            ))}
          </ListTag>}
      </Box>
    </Box>
  );
}
